import types from '../../constants';

const initialState = {
  user: '',
  userId: '',
  password: '',
  userData: {},
  loading: false,
  success: false,
  failed: false,
  message: '',
  isRestoring: false,
  preventPasswordChange: true,
};

const LoginReducers = (state = initialState, action) => {
  switch (action.type) {
    case types.LOGIN_LOADING:
      return {
        ...state,
        loading: true,
        success: false,
        failed: false,
      };
    case types.LOGIN_INITIAL:
      return {
        ...state
      };

    case types.LOGIN_GO_LOGIN:
      return {
        ...state,
        isRestoring: false,
        failed: false,
        message: '',
      };
    case types.LOGIN_GO_RESTORE:
      return {
        ...state,
        isRestoring: true,
        failed: false,
        message: '',
      };
    case types.LOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        failed: false,
        userData: action.payload
      };
    case types.LOGIN_USER_FETCH:
      return {
        ...state,
        loading: false,
        failed: false,
        userData: action.payload
      };
    case types.LOGIN_FAILED:
      return {
        ...state,
        loading: false,
        success: false,
        failed: true,
        message: action.payload,
      };
    case types.LOGIN_CHANGE_USER:
      return {
        ...state,
        user: action.payload,
      };
    case types.LOGIN_CHANGE_PASSWORD:
      return {
        ...state,
        password: action.payload,
      };
    case types.RESTORE_SENT:
      return {
        ...state,
        loading: false,
        success: true,
        failed: false,
      };
    case types.RESTORE_GET_APPROVE:
      return {
        ...state,
        loading: false,
        preventPasswordChange: false,
        userId: action.payload
      };
    default:
      return state;
  }
};

export default LoginReducers;
